module.exports = __webpack_public_path__ + "img/stone104.c3eb881a.png";